import _regeneratorRuntime from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.keys.js";
export default {
  data: function data() {
    return {
      list: [],
      total: 0,
      current: 1,
      // 页码
      perPage: 10,
      rangeBefore: 3,
      rangeAfter: 2,
      id: ""
    };
  },
  computed: {
    totalAmountOwe: function totalAmountOwe() {
      var item = window.sessionStorage.getItem("totalAmountOwe");
      return item ? JSON.parse(item) : 0;
    }
  },
  created: function created() {
    this.id = this.$route.params.id;
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var url, result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.list = [];
              url = "/pjyy-deepexi-user-center/api/v1/companyDebts/details/pageList?summaryId=".concat(_this.id, "&page=").concat(_this.current, "&pageSize=").concat(_this.perPage);
              _context.next = 4;
              return _this.$getHttpClient().get(url);
            case 4:
              result = _context.sent;
              _this.list = result.data.data.list;
              _this.total = result.data.data.total;
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handleChange: function handleChange(val) {
      this.current = val;
      this.getList();
    },
    handleBack: function handleBack() {
      window.history.go(-1);
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.sessionStorage.removeItem("totalAmountOwe");
  }
};